import React from 'react';
import ChartBar from '../../../components/ChartBar';
import { AccountCreationData, SummedReport } from '../../../models/ReportData';
import useChartTheme from '../../../themes/chart';
import { buildReportChartData } from '../../../data/report/helpers/chartUtils';
import { getAccountType } from '../../../data/report/helpers/pricebookReportUtils';

const creationMethodMap = new Map<keyof AccountCreationData, string>([
  ['accountCreationMethodManualCount', 'Manual'],
  ['accountCreationMethodAppleCount', 'Apple SSO'],
  ['accountCreationMethodGoogleCount', 'Google SSO'],
]);

interface CreationMethodChartProps {
  summedReport: SummedReport;
}

const CreationMethodChart: React.FC<CreationMethodChartProps> = ({ summedReport }) => {
  const { chartColors } = useChartTheme();
  const chartData = buildReportChartData(
    summedReport,
    pricebookReport => getAccountType(pricebookReport?.productType),
    creationMethodMap,
  );

  const dataSeries = Object.entries(chartData).map(([accountType, data]) => ({
    data,
    color: chartColors[accountType as keyof typeof chartColors],
    label: accountType,
  }));

  return (
    <ChartBar
      title='Users per account creation method'
      dataSeries={dataSeries}
      yAxisLabel='Count per method'
      seriesLabel='Account type'
    />
  );
};

export default CreationMethodChart;
